import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import './LandingSections.css';

const FeaturedProducts = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const res = await axios.get(`${config.API_URL}/products?limit=3`);
            setProducts(res.data.slice(0, 3)); // Get only 3 latest
            setLoading(false);
        } catch (error) {
            console.error('Error fetching products:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading products...</div>;
    }

    return (
        <section className="featured-section">
            <div className="container">
                <h2>Featured Products</h2>
                <p className="section-subtitle">Check out our latest chess gear and equipment</p>

                <div className="featured-grid">
                    {products.map(product => (
                        <div key={product.id} className="featured-card">
                            <div className="featured-image">
                                <img src={product.imageUrl} alt={product.name} />
                            </div>
                            <div className="featured-content">
                                <h3>{product.name}</h3>
                                <p>{product.description.substring(0, 100)}...</p>
                                <div className="featured-footer">
                                    <span className="price">KSh {product.price.toFixed(2)}</span>
                                    <Link to="/shop" className="btn-view-more">View Shop</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedProducts;
